import { ICreditNoteUpdate } from "../interfaces/invoices";
import { privateApi } from "./axios";

// AVOIRS
export const getCreditNotes = async () => {
    try {
        const response = await privateApi.get("api/creditnotes/proformas");
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteCreditNote = async (id: number) => {
    try {
        const response = await privateApi.delete(`api/creditnotes/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const validateCreditNote = async (ids: number[]) => {
    try {
        const response = await privateApi.post(`api/creditnotes/validates`, { idsCreditNotes: ids });
        return response;
    } catch (error) {
        throw error;
    }
}

export const downloadCreditNote = async (id: number) => {
    try {
        const response = await privateApi.get(`api/creditnotes/documents?ids=${id}`, { responseType: 'blob' });
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateCreditNote = async (id: number, data: ICreditNoteUpdate) => {
    try {
        const response = await privateApi.patch(`api/creditnotes/${id}`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getCreditNote = async (id: number) => {
    try {
        const response = await privateApi.get(`api/creditnotes/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}